import { FormikProvider, useFormik } from 'formik';
import { forwardRef, useImperativeHandle } from 'react';
import { TextArea } from 'src/shared-components/Form';
import * as Yup from 'yup';

interface FormBriefProps {
  onFormSubmitted: (values: any) => void;
  initialValues: any;
  update: boolean;
}

const FormBrief = forwardRef(({ onFormSubmitted, initialValues, update = false }: FormBriefProps, ref) => {
  const form = useFormik({
    initialValues,
    validationSchema: Yup.object({
      brief: Yup.string().required('Hey we need a project brief to get going'),
    }),
    onSubmit: values => {
      if (update) {
        onFormSubmitted({ brief: { set: values.brief } });
      } else {
        onFormSubmitted({ brief: values.brief });
      }
    },
  });

  useImperativeHandle(ref, () => ({
    submitForm() {
      form.submitForm();
    },
  }));

  return (
    <FormikProvider value={form}>
      <div data-testid="form-brief" className="grid grid-cols-6 gap-4">
        <div className="col-span-6 sm:col-span-6">
          <TextArea
            id="brief"
            name="brief"
            autoComplete="off"
            label="Project brief"
            placeholder="We’re looking to launch the app across mobile and web. For the front-end engineer, we’ll need someone that is comfortable with React Native Web, TypeScript, NextJS."
            required
            rows={8}
          />
        </div>
      </div>
    </FormikProvider>
  );
});

export default FormBrief;
